import { render } from "./AllowanceUpdateModal.vue?vue&type=template&id=50b8bfa0"
import script from "./AllowanceUpdateModal.vue?vue&type=script&lang=js"
export * from "./AllowanceUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__